import React, { useEffect, useRef, useState } from 'react';
import { ReactBingmaps } from 'react-bingmaps';

const DEFAULT_CENTER = [21.0285, 105.8542];
const mapOptions = {
  liteMode: true,
  showLocateMeButton: false,
  showMapTypeSelector: false,
  showScalebar: false,
  showTermsLink: false,
  showZoomButtons: false,
  showDashboard: false,
  showBreadcrumb: false,
  enableClickableLogo: false,
};

const greeting = () => {
  const hour = new Date().getHours();
  if (hour < 11) return 'Chào buổi sáng';
  if (hour < 14) return 'Chào buổi trưa';
  if (hour < 18) return 'Chào buổi chiều';
  return 'Chào buổi tối';
};

// Restore the CMS's original map provider. This uses the existing Bing key,
// so it does not require a Google Cloud browser key or a billing setup.
const RideHomeMap = ({ onPickFromMap, onCurrentLocation }) => {
  const [center, setCenter] = useState(DEFAULT_CENTER);
  const bestAccuracyRef = useRef(Number.POSITIVE_INFINITY);

  useEffect(() => {
    if (!navigator.geolocation) return undefined;
    let active = true;
    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const accuracy = Number(position.coords.accuracy);
        if (!active || (!Number.isNaN(accuracy) && accuracy >= bestAccuracyRef.current)) return;
        bestAccuracyRef.current = accuracy;
        const point = [position.coords.latitude, position.coords.longitude];
        setCenter(point);
        onCurrentLocation?.({ latitude: point[0], longitude: point[1], accuracy });
      },
      () => {},
      { enableHighAccuracy: true, maximumAge: 0, timeout: 12000 },
    );
    return () => { active = false; navigator.geolocation.clearWatch(watchId); };
  }, [onCurrentLocation]);

  return <div className="map ride-home-map" aria-label="Bản đồ vị trí hiện tại">
    <div className="ride-home-map__canvas">
      <ReactBingmaps
        key={`ride-home-map-${center.join('-')}`}
        id="ride-home-bing-map"
        bingmapKey={process.env.REACT_APP_BING_MAP_API_KEY}
        center={center}
        zoom={15}
        mapTypeId="road"
        mapOptions={mapOptions}
        pushPins={[{ location: center, option: { color: '#4285f4' } }]}
      />
    </div>
    <div className="ride-home-map__veil" />
    <div className="ride-home-map__content">
      <div className="ride-home-map__topline">
        <strong>{greeting()}</strong>
        <button type="button" className="ride-home-map__pick" onClick={onPickFromMap}>
          <i className="fa-regular fa-map" /> Chọn trên bản đồ
        </button>
      </div>
      <h2>Bạn muốn đi đâu?</h2>
    </div>
  </div>;
};

export default RideHomeMap;
